import React from "react";

export default function LoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-black text-white">
      <div className="glass-card rounded-3xl px-6 py-8 text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-blue-300">
          Jantabo Scholarship Initiative
        </p>
        <p className="mt-3 text-lg font-semibold">Loading portal…</p>
      </div>
    </div>
  );
}
